import tableList from "@/mixins/module/tableList";
import form from "@/mixins/module/form";
import popup from "@/mixins/module/popup"
import dict from "@/mixins/module/dict";
import getDist from "@/mixins/module/getDist";
import list from "@/mixins/module/ListMixin";
import FinancialNeedYear from "@/mixins/module/financialNeedYear";

export const tableListMixin = tableList;
export const dictMixin = dict;
export const formMixin = form;
export const popupMixin = popup;
export const getDistMixin = getDist;
export const listMixin = list;
export const financialNeedYear = FinancialNeedYear;
